<template>
  <main-layout>
    <template slot="header">
      <h1>{{ contest.title[lang] }}</h1>
      <p>{{ contest.description[lang] }}</p>
    </template>

    <template slot="main">
      <h2>{{ $t('contest.section.rounds.title') }}</h2>
      <div class="contest rounds">
        <round-card v-if="rounds.length > 0" v-for="round in rounds" :key="round.id" :id="round.id"></round-card>
        <div class="add-round" @click="redirectToRoundForm">
          <font-awesome-icon icon="plus"></font-awesome-icon><span>round</span>
        </div>
      </div>
      <ranking :id="id"></ranking>
    </template>
  </main-layout>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import RoundCard from '@/components/rounds/round-card.vue'
import Ranking from '@/components/contests/contest-ranking.vue'

export default {
  name: 'contest',

  components: { RoundCard, Ranking },

  props: {
    id: {
      type: String,
      required: true
    }
  },

  computed: {
    ...mapGetters('account', {
      site: 'currentSite',
      lang: 'defaultLang'
    }),
    ...mapGetters('rounds', {
      rounds: 'rounds'
    }),

    ...mapGetters('contest', {
      getById: 'getById'
    }),

    contest () {
      return this.getById(this.id)
    }
  },

  watch: {
    site: {
      handler: 'initContest',
      immediate: true
    }
  },

  methods: {
    ...mapActions('rounds',
      ['loadRoundsByContest', 'addRound', 'addResponses', 'updateRound', 'removeRound']),

    ...mapActions('contest',
      ['loadContest', 'getContestRank']),

    isEditable (round) {
      let closedate = moment(round.closedate)
      let diff = moment().diff(closedate, 'secondes')
      if (diff > 0) {
        return false
      }
      return true
    },

    initContest () {
      if (this.site) {
        // 1. Load the contest
        this.loadContest({id: this.id})
          .then(() => {
            // 2. Load the rounds
            this.loadRoundsByContest({idContest: this.id})
              .then(() => {

              }).catch(() => {
                this.$vs.notify({text: 'An error has occured', color: 'danger', icon: 'check', position: 'top-right'})
              })
          }).catch(() => {
            this.$vs.notify({text: 'An error has occured', color: 'danger', icon: 'check', position: 'top-right'})
          })
      }
    },
    redirectToRoundDetails (round) {
      this.$router.push({ name: 'round-edit', params: { idContest: this.id, id: round.id } })
    },
    redirectToRoundForm () {
      this.$router.push({ name: 'round-create', params: { idContest: this.id } })
    }
  }
}
</script>

<style lang="scss" scoped>

h2 {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 16px;
}
.rounds {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-gap: 24px;
    margin-bottom:40px;

    .item {
        padding: 20px;
        > .title {
            display: grid;
            grid-template-columns: 1fr 20px;

            .group-actions {
                float: right;
                height: 24px;
            }
        }

        .description {
            margin-bottom: 12px;
        }

        .end-date {
            span {
                margin-left: 8px;
            }
        }
    }

    .title {
        margin-bottom: 8px;
        .tag {
            color:#fff;
            font-size: 13px;
            display: inline-block;
            margin-right: 8px;
            border-radius: 4px;
            font-weight: 400;
            padding: 4px 8px;
            background: #6C7A89;
            &.running {
                background: #3FC380;
            }
            &.closed {
                background: #446CB3;
            }
        }

    }
}
.add-round {
    border: 1px dashed #aaa;
    background: #fefefe;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    cursor: pointer;

    > span {
        margin: 8px;
    }

    &:hover {
        background: #fafafa;
        > span {
            text-decoration: underline;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/Contest/Contest.vue